<script>
    import TileHosting from './TileHosting.svelte'
    import { selectedHostingPlan } from '../stores.js';

    let hostingPlans = [
        {
            'title' : 'S',
            'price' : 10,
            'description' : 'VPS partagé<br>10GB SSD<br>1 site max',
            'speed' : 1,
            'power' : 1,
        },
        {
            'title' : 'M',
            'price' : 22,
            'description' : '2GB Ram<br>1vCore<br>64GB SSD<br>sites illimités',
            'speed' : 2,
            'power' : 1,
        },
        {
            'title' : 'L',
            'price' : 42,
            'description' : '4GB Ram<br>2vCore<br>128GB SSD<br>sites illimités',
            'speed' : 3,
            'power' : 3,
        },
        {
            'title' : 'XL',
            'price' : 80,
            'description' : '8GB Ram<br>3vCore<br>256GB SSD<br>sites illimités',
            'speed' : 4,
            'power' : 4,
        },
        {
            'custom' : true,
            'title' : 'Sur Mesure',
            'price' : 100,
            'description' : 'Jusqu\’à 48GB Ram<br>Jusqu\’à  12vCore<br>Jusqu\’à  768GB SSD<br>sites illimités',
            'speed' : 1,
            'power' : 2,
        },
    ]

    // To preselect the hosting plan :
    $selectedHostingPlan = hostingPlans[1];

</script>

<div class="hosting-plans-tile">
    {#each hostingPlans as plan}
        <TileHosting {plan}/>  
    {/each}
</div>

<style>
    .hosting-plans-tile{
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        column-gap: 24px;
    }

    @media all and (max-width: 900px) {
        .hosting-plans-tile {
            grid-template-columns: repeat(1, 100%);
            row-gap: 24px;
            max-width: 400px;
            margin: auto;
        }
    }
</style>